module.exports = {
      id: "edit_pen_inside_the_square-usage",
      viewBox: "0 0 21 20",
      url: __webpack_public_path__ + "assets/img/sprite-6589e8.svg#edit_pen_inside_the_square-usage",
      toString: function () {
        return this.url;
      }
    }